/** Where there is no WebAudio: every method does nothing, except say which music files exist. */

import { musicFileNames } from './fileMusic';
import type { GameAudio } from './types';

export class SilentAudio implements GameAudio {
  unlock(): void {}
  events(): void {}
  ambience(): void {}
  ui(): void {}
  music(): void {}
  setVolumes(): void {}
  hush(): void {}
  tracks(): string[] {
    return musicFileNames();
  }
}
